/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The CampaignControllerDtoPlayStoreSearchResponse model module.
 * @module model/CampaignControllerDtoPlayStoreSearchResponse
 * @version 1.0
 */
class CampaignControllerDtoPlayStoreSearchResponse {
    /**
     * Constructs a new <code>CampaignControllerDtoPlayStoreSearchResponse</code>.
     * @alias module:model/CampaignControllerDtoPlayStoreSearchResponse
     */
    constructor() { 
        
        CampaignControllerDtoPlayStoreSearchResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoPlayStoreSearchResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoPlayStoreSearchResponse} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoPlayStoreSearchResponse} The populated <code>CampaignControllerDtoPlayStoreSearchResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoPlayStoreSearchResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('category')) {
                obj['category'] = ApiClient.convertToType(data['category'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('developerName')) {
                obj['developerName'] = ApiClient.convertToType(data['developerName'], 'String');
            }
            if (data.hasOwnProperty('profileImage')) {
                obj['profileImage'] = ApiClient.convertToType(data['profileImage'], 'String');
            }
            if (data.hasOwnProperty('appUrl')) {
                obj['appUrl'] = ApiClient.convertToType(data['appUrl'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoPlayStoreSearchResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoPlayStoreSearchResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
            throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['developerName'] && !(typeof data['developerName'] === 'string' || data['developerName'] instanceof String)) {
            throw new Error("Expected the field `developerName` to be a primitive type in the JSON string but got " + data['developerName']);
        }
        // ensure the json data is a string
        if (data['profileImage'] && !(typeof data['profileImage'] === 'string' || data['profileImage'] instanceof String)) {
            throw new Error("Expected the field `profileImage` to be a primitive type in the JSON string but got " + data['profileImage']);
        }
        // ensure the json data is a string
        if (data['appUrl'] && !(typeof data['appUrl'] === 'string' || data['appUrl'] instanceof String)) {
            throw new Error("Expected the field `appUrl` to be a primitive type in the JSON string but got " + data['appUrl']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['contentsReward'] = undefined;

/**
 * @member {String} id
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['id'] = undefined;

/**
 * @member {String} category
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['category'] = undefined;

/**
 * @member {String} name
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['name'] = undefined;

/**
 * @member {String} developerName
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['developerName'] = undefined;

/**
 * @member {String} profileImage
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['profileImage'] = undefined;

/**
 * @member {String} appUrl
 */
CampaignControllerDtoPlayStoreSearchResponse.prototype['appUrl'] = undefined;






export default CampaignControllerDtoPlayStoreSearchResponse;

